//React
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

//Chakra
import {
  SimpleGrid,
  VStack,
  Box,
  Text,
  Flex,
  Button,
  Center,
  Input,
  FormControl,
  Textarea,
  FormErrorMessage,
  Icon,
} from "@chakra-ui/react";

//Custom Component
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.js";

//Endpoint
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateOrderInvoice } from "service/order.service";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useAppToast } from "utils/toastUtil";

export default function OrderTransactionForm({
  order,
  invoice_type,
  price,
  is_referral = 0,
  is_refund = 0,
  setTransactionMethod,
}) {
  const { showToast } = useAppToast();
  const history = useHistory();

  //form
  const formik = useFormik({
    initialValues: {
      order_id: order?.id ?? "",
      order_attendance_id: order?.order_attendances[0]?.id ?? "",
      payment_no: "",
      payment_method: "Bank Transfer",
      payment_gateway: "FPX",
      currency: "RM",
      amount: price,
      remarks: "",
      is_referral: is_referral,
      is_refund: is_refund,
    },

    validationSchema: Yup.object().shape({
      payment_no: Yup.string().required("required"),
      amount: Yup.string().required("required"),
      remarks: Yup.string(),
      is_referral: Yup.bool().required("required"),
    }),

    onSubmit: async (values) => {
      try {
        const { data } = await updateOrderInvoice(values);

        if (data) {
          showToast({
            title: "Success!",
            description: "Payment released",
            status: "success",
          });
          setTransactionMethod(false);
          history.push({
            pathname: `/admin/order`,
          });
        }
      } catch (error) {
        showToast({
          title: "Failure!",
          description: "Error in process",
          status: "error",
        });
        console.log(error);
        // throw error
      }
    },
  });

  //setup
  useEffect(() => {
    // getOrder(route_param.orderId);
  }, []);
  //component

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
        <CardHeader p="6px 0px 22px 0px">
          <Button
            bg={"transparent"}
            my={"auto"}
            onClick={() => {
              setTransactionMethod(false);
            }}
          >
            <Icon as={ArrowBackIcon} h={"10"} w={"10"} color={"white"} mx={"2"} />
          </Button>
          <Text
            fontSize="lg"
            color="#fff"
            fontWeight="bold"
            textColor={"blue.200"}
            textTransform={"uppercase"}
            my={"auto"}
          >
            Transaction Details -
          </Text>
          <Text
            fontSize="lg"
            color="#fff"
            fontWeight="bold"
            textColor={invoice_type == "gigger" ? "limegreen" : "beige"}
            textTransform={"uppercase"}
            mx={2}
            my={"auto"}
          >
            {invoice_type}
          </Text>
        </CardHeader>
        <CardBody w={"full"}>
          <SimpleGrid
            w={"full"}
            my={"4"}
            px={"4"}
            columns={{ base: 1, md: 2 }}
            spacing={{ base: "12", md: "12" }}
          >
            <FormControl
              isInvalid={!!(formik?.errors.payment_no && formik?.touched.payment_no)}
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Payment No. (Bank Receipt Reference)</Text>
                <Input {...formik.getFieldProps("payment_no")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.payment_no}
                </FormErrorMessage>
              </VStack>
            </FormControl>
            <FormControl
              isInvalid={
                !!(formik?.errors.payment_method && formik?.touched.payment_method)
              }
              isDisabled
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Payment Method</Text>
                <Input {...formik.getFieldProps("payment_method")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.payment_method}
                </FormErrorMessage>
              </VStack>
            </FormControl>
            <FormControl
              isInvalid={
                !!(formik?.errors.payment_gateway && formik?.touched.payment_gateway)
              }
              isDisabled
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Payment Gateway</Text>
                <Input {...formik.getFieldProps("payment_gateway")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.payment_gateway}
                </FormErrorMessage>
              </VStack>
            </FormControl>
            <FormControl
              isInvalid={!!(formik?.errors.currency && formik?.touched.currency)}
              isDisabled
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Currency</Text>
                <Input {...formik.getFieldProps("currency")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.currency}
                </FormErrorMessage>
              </VStack>
            </FormControl>
            <FormControl
              isInvalid={!!(formik?.errors.amount && formik?.touched.amount)}
              isDisabled
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Amount</Text>
                <Input {...formik.getFieldProps("amount")} bg={"white"} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.amount}
                </FormErrorMessage>
              </VStack>
            </FormControl>
            <FormControl
              isInvalid={!!(formik?.errors.remarks && formik?.touched.remarks)}
            >
              <VStack alignItems={"start"} my={"3"}>
                <Text color={"white"}>Remarks</Text>
                <Textarea {...formik.getFieldProps("remarks")} bg={"white"} rows={5} />
                <FormErrorMessage bottom={"-6"} position={"absolute"} textColor={"red"}>
                  {formik?.errors.remarks}
                </FormErrorMessage>
              </VStack>
            </FormControl>

            <Button
              // disabled={kycUser.know_your_client.verification_status != "approved"}
              variant="brand"
              fontSize="10px"
              type="submit"
              w="100%"
              maxW="350px"
              h="45"
              mb="20px"
              mt="20px"
              mx={"2"}
              textTransform={"uppercase"}
              fontWeight={"bold"}
              backgroundColor={"green.500"}
              isLoading={formik.isSubmitting}
              // onClick={() => {
              //   console.log("to update invoice");

              //   formik.submitForm;

              //   console.log("updated invoice");
              // }}
              onClick={formik.submitForm}
            >
              Update Payment Release
            </Button>
          </SimpleGrid>
        </CardBody>
      </Card>
    </Flex>
  );
}
